export const Base_Api="https://brytalent.dev-iuh.xyz"
